module.exports = "<div class=\"countdown-widget\"> {{ remainingTime }} </div>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/countdownWidget/countdown-widget.component.html
// module id = ../../../../../app/shared/components/countdownWidget/countdown-widget.component.html
// module chunks = main